import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type ContactPhone } from "@/lib/types";
import { omit } from "lodash";
import { baseContactRoute } from "./contact";

export function createContactPhoneV1(
  data: Pick<ContactPhone, "number" | "label" | "contactId"> &
    Partial<ContactPhone>,
) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<ContactPhone>>(`${baseContactRoute}/phones`, data)
    .then((res) => res.data);
}

export function updateContactPhoneV1(
  data: Pick<ContactPhone, "contactId" | "id" | "dateModified"> &
    Partial<ContactPhone>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<ContactPhone>
    >(`${baseContactRoute}/phones`, omit(data, "contactId"))
    .then((res) => res.data);
}

export function deleteContactPhoneV1({
  id,
}: {
  contactId: string;
  id: string;
}) {
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<ContactPhone>>(`${baseContactRoute}/phones/${id}`)
    .then((res) => res.data);
}
